import * as React from 'react';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import ErrorsCore from '../AfrCore/ErrorsCore';

const CR939ErrorsA = (props: any) => {

    return (
        <React.Fragment>
            <ErrorsCore userRole="ADMIN" taxType={TaxonomyTypeEnum.COURT_REPORTING_939} reportName="Court Report 939.185" />
        </React.Fragment>
    );
}

export default CR939ErrorsA;